import { useState } from "react"
import { Button } from "@/components/ui/button.tsx"
import { Check, Copy } from "lucide-react"

/**
 * Small inline copy button that copies text to the clipboard.
 * Shows a checkmark briefly after a successful copy.
 *
 * @param text - The string to copy to the clipboard.
 */
export function CopyButton({ text }: { text: string }) {
  const [copied, setCopied] = useState<boolean>(false)

  async function handleCopy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch {
      // Clipboard API may fail in insecure contexts — silently ignore
    }
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      className="h-5 w-5 shrink-0"
      onClick={handleCopy}
      title={copied ? "Copied!" : "Copy to clipboard"}
    >
      {copied ? (
        <Check className="h-3 w-3 text-green-500" />
      ) : (
        <Copy className="h-3 w-3 text-muted-foreground" />
      )}
    </Button>
  )
}